import { useState } from "react";
import { UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { isMine } from "@/lib/mobile";
import { cn } from "@/lib/utils";

export function useMine() {
  const { session } = useAuth();
  const u = session.user;
  const key = `m_mine_${u.id}`;
  const [mine, setMineState] = useState(() => localStorage.getItem(key) === "1");
  const setMine = (v) => { localStorage.setItem(key, v ? "1" : "0"); setMineState(v); };
  const enabled = !!u.waiter_view;
  const apply = (list) => (enabled && mine ? list.filter((c) => isMine(c, u)) : list);
  return { enabled, mine: enabled && mine, setMine, apply };
}

export function MineToggle({ mine, setMine, count }) {
  return (
    <button onClick={() => setMine(!mine)} data-testid="m-mine-toggle"
      className={cn("flex h-10 items-center gap-1.5 rounded-full px-4 text-sm font-semibold transition-colors",
        mine ? "bg-[#1565c0] text-white shadow-md shadow-blue-900/20" : "bg-white text-[#0d47a1] ring-1 ring-slate-200")}>
      <UserRound className="h-4 w-4" />Minhas comandas{mine && count != null ? ` (${count})` : ""}
    </button>
  );
}
